import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { CenterOptionsRedux } from '../Redux/CenterOptionsRedux'

const centerOptionsCrudObservable = createCRUDObservable({
  mainRedux: CenterOptionsRedux,
  reduxPath: 'centerOptions',
})

export const centerOptionsObservers = Object.assign({}, centerOptionsCrudObservable.observers, {})

export const centerOptionsEpic = combineEpics(
  centerOptionsCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CenterOptionsObservable.js